export default {
  label: 'Publicaciones con id',
};
